<template>
  <v-dialog persistent v-model="show" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">コンテナNo更新</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="hasSpace" @click="submit">更新</v-btn>
        <v-btn @click="show = false">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              @change="removeSpace()"
              label="コンテナNo"
              v-model="containerNo"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['deliveryOrder', 'sourceContainerNo'],
  data: () => ({
    show: false,
    containerNo: null,
    errors: {
      CONTAINER_NO_EXIST:
        '既に登録されているコンテナ No.への変更はできません。',
      DO_HAS_CONFIRMED:
        'DO 確定されている場合、コンテナ No.の変更はできません。',
      SHIPMENT_HAS_CHANGED:
        '当該データのステータスは更新されたため、画面更新してからもう一度お試してください。',
    },
  }),
  methods: {
    submit() {
      if (!this.containerNo) {
        this.$message(
          '',
          'コンテナNoが空白になるので、コンテナNo入力してください。'
        )
        return
      }
      this.$http
        .put(
          `/delivery-orders/${
            this.deliveryOrder.id
          }/updateContainerNo?version=${this.deliveryOrder.version}`,
          {
            sourceContainerNo: this.sourceContainerNo,
            targetContainerNo: this.containerNo,
          }
        )
        .then(() => {
          this.$message('', 'コンテナナンバーの変更が完了しました。')
          this.show = false
          this.$emit('refresh')
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    popup() {
      this.show = true
    },
    removeSpace() {
      this.containerNo = this.containerNo.replaceAll(' ', '')
    },
  },
  computed: {
    hasSpace() {
      return this.containerNo && this.containerNo.indexOf(' ') > -1
    },
  },
}
</script>
